<template>
  <div v-if="isContractor || isPartner" style="padding: 20px">
    <div class="notification-group">
      <b-notification
              :closable="false"
              type="notification-block"
              :message="notificationMessage"
      />
    </div>
    <PayoutMethod :edit-immediately="$route.params.action === 'ach'"></PayoutMethod>
    <TaxForm :open-form-immediately="$route.params.action === 'w9'"></TaxForm>
  </div>
</template>

<script>
import PayoutMethod from '@/components/PayoutTax/PayoutMethod.vue';
import TaxForm from '@/components/PayoutTax/TaxForm.vue';

const NOTIFICATION_TAIL = `Payments are made on a monthly basis; however, a W-9 form is required when
  the total amount reaches $600 during the calendar year. All payable amounts can be
  found in the Reports - Commissions, specifically in the Commissions column.<br/>
  Note: no bonuses will be paid if you do not provide your ACH information
  (and W-9 form when required).`;

export default {
  name: 'PayoutTax',
  components: {
    PayoutMethod,
    TaxForm,
  },
  computed: {
    isConcierge() {
      if (this.$store.state.contractor.id) {
        return this.$store.state.contractor.plan.tier === 'Concierge';
      }
      return false;
    },
    isContractor() {
      return !!this.$store.state.contractor.id;
    },
    isPartner() {
      return !this.$store.state.contractor.id
        && !!this.$store.state.partner.id;
    },
    notificationMessage() {
      let lead;
      if (this.isConcierge) {
        lead = 'We use ACH to pay referral bonus.';
      } else if (this.isPartner) {
        lead = 'We use ACH to pay partner bonus.';
      } else {
        lead = 'We use ACH to pay commissions and referral bonuses.';
      }
      return `${lead} ${NOTIFICATION_TAIL}`;
    },
  },
};
</script>

<style lang="stylus">
.payout-tax
  &__title
    color #447086
    font-weight bold
    font-size 16px
    margin-bottom 15px
  .label&__field-label
    font-weight normal
    color #969EA2
    font-size 14px
.payout-tax-list
  &__item
    border-bottom 1px solid #DDDFE2
    padding-bottom 20px
    margin-bottom 20px
  .buttons
    .button
      min-width 110px
      height 48px
      text-transform uppercase
    .button.is-success
      border 1px solid #68BA62
      &:hover
        color #fff
        background-color #17B548
        border-color #17B548
    .button:not(.is-success)
      color #68BA62
      background-color transparent
      border 1px solid #68BA62
      &:hover
        color #fff
        background-color #17B548
        border-color #17B548
.columns .buttons
  flex-wrap nowrap
.notification-group
  margin-bottom 1.5rem
</style>
